<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { KhSelect } from '@internal-libraries/kheops-ui-lib'
import { useConfigStore } from '../../../../Store/configStore'
import { useSnackStore } from '../../../../Store/snackStore'
import KhListEntryConfig from "../../../../Type/KhListEntryConfig";

interface Props {
    value?: string
    className: string
    listKeyName: string
}

const props = withDefaults(defineProps<Props>(), {
    value: null,
})

const emit = defineEmits<{
    (e: 'input', value: string | null): void
}>()

const configStore = useConfigStore()
const snackStore = useSnackStore()
const itemList = ref<KhListEntryConfig[]>([])
const loading = ref(false)

watch(() => configStore.currentEstablishment, () => {
    loadItems()
})

onMounted(() => {
    loadItems()
})

const loadItems = () => {
    if (!props.listKeyName) return

    loading.value = true
    const groupId = configStore.currentEstablishment ?? 'global'
    
    configStore.loadItemListConfiguration(props.listKeyName, groupId, props.className).subscribe(
        result => {
            itemList.value = result.getManyData() ?? []
            loading.value = false
        },
        error => {
            snackStore.manageApiError(error)
            loading.value = false
        },
    )
}
</script>

<template>
    <kh-select
        :items="itemList"
        :loading="loading"
        v-model="value"
        @input="(newValue) => emit('input', newValue)"
        item-value="id"
        item-text="name"
        clearable
        dense
    />
</template>